export default __webpack_public_path__ + "static/media/trip_banner.cfd372d6.png";